<script setup lang="ts">
import { type SelectionItem } from '@models/selectionItem.ts';
import Typography from '@components/Typography.vue';
import { transchoice } from '@elements/translation';
import SelectionItemRestoreButton from './SelectionItemRestoreButton.vue';

defineProps<{ selectionItem: SelectionItem }>();
</script>

<template>
  <div class="selection-item-removed-actions">
    <div>
      <Typography
        variant="body-small-bold"
        class="selection-item-removed-actions__title"
      >
        {{
          transchoice('selection_item.removed.item.title', {
            count: selectionItem.refusal_reasons.length,
            author: selectionItem.removed_by?.firstname ?? selectionItem.user.firstname
          })
        }}
      </Typography>

      <Typography
        variant="body-small"
        class="selection-item-removed-actions__description"
      >
        {{ selectionItem.refusal_reasons.join('; ') }}
      </Typography>
    </div>

    <SelectionItemRestoreButton :selection-item-id="selectionItem.id" />
  </div>
</template>

<style scoped lang="scss">
@use '@styles/variables' as *;
@use '@styles/mixins' as *;

.selection-item-removed-actions {
  border-radius: rem(8);
  padding: rem(8);
  display: flex;
  justify-content: space-between;
  gap: rem(8);
  background-color: $colorGray;
}
</style>
